import { MY_PAGE_PATH } from './my-page-path';

/** 마이페이지 "내 주문" 목록·상세(주문 설계 §8-2) — 마이페이지 아래에 둔다. */
export const MY_ORDERS_PATH = `${MY_PAGE_PATH}/orders`;
export const myOrderDetailPath = (orderId: string): string =>
  `${MY_ORDERS_PATH}/${encodeURIComponent(orderId)}`;

/** 후기 — 내 후기 목록, 주문별 작성, 후기별 수정(후기 설계). */
export const MY_REVIEWS_PATH = `${MY_PAGE_PATH}/reviews`;
export const reviewWritePath = (orderId: string): string =>
  `${MY_ORDERS_PATH}/${encodeURIComponent(orderId)}/review`;
export const reviewEditPath = (reviewId: string): string =>
  `${MY_REVIEWS_PATH}/${encodeURIComponent(reviewId)}/edit`;
/** 교환·환불 문의 접수 — 내 주문 상세 아래 별도 화면(문의 설계 D12). */
export const orderInquiryWritePath = (orderId: string): string =>
  `${MY_ORDERS_PATH}/${encodeURIComponent(orderId)}/inquiry`;

/** 주문하기 화면(견적 설계 §7-4·§7-5) — 라우트는 `${ORDER_PLACE_PATH}/:quoteRequestId` 다. */
export const ORDER_PLACE_PATH = '/orders/place';
export const orderPlacePath = (quoteRequestId: string): string =>
  `${ORDER_PLACE_PATH}/${encodeURIComponent(quoteRequestId)}`;

/** 스토어 라우트 경로 — 목록·상세·커스터마이징이 공유하는 단일 원천. */

export const STORE_PATH = '/store';
/** 커스터마이징 에디터 라우트 패턴 — 라우트 표와 "에디터에서는 숨기는" 위젯(카카오톡 상담 버튼)이 같이 쓴다. */
export const STORE_CUSTOMIZE_ROUTE_PATTERN = `${STORE_PATH}/:productId/customize`;

/** 고객 포트폴리오 — GNB와 목록·상세가 공유한다. */
export const PORTFOLIO_PATH = '/portfolio';
export const portfolioDetailPath = (id: string): string =>
  `${PORTFOLIO_PATH}/${encodeURIComponent(id)}`;
export const portfolioListPath = ({
  categoryId,
  page = 1,
}: {
  categoryId?: string;
  page?: number;
} = {}): string => {
  const query = new URLSearchParams();
  if (categoryId) query.set('category', categoryId);
  if (page > 1) query.set('page', String(page));
  const suffix = query.toString();
  return suffix ? `${PORTFOLIO_PATH}?${suffix}` : PORTFOLIO_PATH;
};

export const storeProductPath = (productId: string): string => `${STORE_PATH}/${productId}`;

/** 목록을 한 카테고리로 좁힌 주소 — 쿼리 이름은 /store 가 읽는 category 와 같아야 한다. */
export const storeCategoryPath = (categoryId: string): string =>
  `${STORE_PATH}?category=${encodeURIComponent(categoryId)}`;

/** 스토어 목록의 기획전 필터 쿼리 파라미터 — 카드 링크·URL 해석·직렬화가 함께 쓰는 단일 원천. */
export const STORE_EXHIBITION_PARAM = 'exhibition';

/** 기획전 페이지의 선택된 목적 탭 쿼리 파라미터 — 페이지와 그 스펙이 함께 쓰는 단일 원천. */
export const EXHIBITION_PURPOSE_PARAM = 'purpose';

export const storeExhibitionPath = (exhibitionId: string): string =>
  `${STORE_PATH}?${STORE_EXHIBITION_PARAM}=${exhibitionId}`;

/** 약관 — 본문 화면은 준비중이며 푸터가 연결한다. */
export const PRIVACY_POLICY_PATH = '/privacy';
export const TERMS_OF_SERVICE_PATH = '/terms';

/** 커스터마이징 화면이 처음 색상으로 읽는 쿼리 이름 — 상세에서 고른 색상을 에디터로 잇는다(새 문서일 때만 쓴다). */
export const CUSTOMIZE_COLOR_PARAM = 'color';

/**
 * 상세의 [커스터마이징 시작] CTA 목적지. 색상을 주면 `?color=` 로 실어 에디터가 그 색상으로 시작한다 —
 * 없으면(null/undefined) 쿼리 없이 에디터 기본 색상을 쓴다.
 */
export const storeCustomizePath = (productId: string, colorOptionId?: string | null): string => {
  const base = `${storeProductPath(productId)}/customize`;
  return colorOptionId === undefined || colorOptionId === null
    ? base
    : `${base}?${CUSTOMIZE_COLOR_PARAM}=${encodeURIComponent(colorOptionId)}`;
};

/** 결제 — 결제·성공·실패 페이지(결제 설계 §11). 성공·실패 주소는 토스 결제창이 돌아오는 곳이다. */
export const PAYMENT_CHECKOUT_PATH = '/payments/checkout';
export const PAYMENT_SUCCESS_PATH = '/payments/success';
export const PAYMENT_FAIL_PATH = '/payments/fail';

/** 결제 페이지가 읽는 우리 주문 ID 쿼리 이름. */
export const PAYMENT_CHECKOUT_ORDER_PARAM = 'orderId';

/** 실패 주소에 붙이는 우리 주문 ID 쿼리 이름 — 토스가 붙이는 orderId(=payments.id)와 겹치지 않게 다른 이름을 쓴다. */
export const PAYMENT_FAIL_ORDER_PARAM = 'order';

export const paymentCheckoutPath = (orderId: string): string =>
  `${PAYMENT_CHECKOUT_PATH}?${PAYMENT_CHECKOUT_ORDER_PARAM}=${encodeURIComponent(orderId)}`;

export const paymentFailPath = (orderId: string): string =>
  `${PAYMENT_FAIL_PATH}?${PAYMENT_FAIL_ORDER_PARAM}=${encodeURIComponent(orderId)}`;

/** 회사 소개 — GNB ABOUT 메뉴의 목적지. */
export const ABOUT_PATH = '/about';

/** 견적문의 — GNB 메뉴와 HOME 보조 버튼이 함께 쓴다. 디자인별 요청 페이지는 그 아래 /request/:designId 다. */
export const QUOTE_REQUEST_PATH = '/request';

/** 견적 요청 화면이 처음 수량으로 읽는 쿼리 이름 — 에디터에서 고른 수량을 잇는다. */
export const QUOTE_REQUEST_QTY_PARAM = 'qty';

export const quoteRequestPath = (designId: string, qty?: number | null): string => {
  const base = `${QUOTE_REQUEST_PATH}/${encodeURIComponent(designId)}`;
  return qty === undefined || qty === null ? base : `${base}?${QUOTE_REQUEST_QTY_PARAM}=${qty}`;
};

/**
 * 비회원 견적 요청 화면(G12) — 공개 라우트. `/request/:designId` 보다 구체적인 정적 경로라 라우터가 먼저 고른다.
 * 에디터가 임시 작업(localStorage)을 남기고 상품·색상·수량을 쿼리로 넘긴다.
 */
export const GUEST_QUOTE_REQUEST_PATH = '/request/guest';

/** 비회원 견적 요청 화면이 읽는 상품·색상 쿼리 이름 — 수량은 회원 요청과 같은 QUOTE_REQUEST_QTY_PARAM 이다. */
export const GUEST_QUOTE_REQUEST_PRODUCT_PARAM = 'productId';
export const GUEST_QUOTE_REQUEST_COLOR_PARAM = 'colorId';

export const guestQuoteRequestPath = ({
  productId,
  colorOptionId,
  quantity,
}: {
  readonly productId: string;
  readonly colorOptionId: string;
  readonly quantity?: number | null;
}): string => {
  const query = new URLSearchParams();
  query.set(GUEST_QUOTE_REQUEST_PRODUCT_PARAM, productId);
  query.set(GUEST_QUOTE_REQUEST_COLOR_PARAM, colorOptionId);
  if (quantity !== undefined && quantity !== null)
    query.set(QUOTE_REQUEST_QTY_PARAM, String(quantity));
  return `${GUEST_QUOTE_REQUEST_PATH}?${query.toString()}`;
};

/**
 * 일반 견적 요청 화면 — 편집영역이 없는(인쇄 없는) 상품을 디자인 없이 바로 요청한다. 회원·비회원이 같은 경로를 쓰고,
 * `/request/:designId` 보다 구체적인 정적 접두라 라우터가 먼저 고른다.
 */
export const PLAIN_QUOTE_REQUEST_PATH = '/request/product';

/** 일반 견적 요청 주소 — 색상은 커스터마이징과 같은 `?color=`, 수량은 `?qty=` 로 싣고 없는 값(null/생략)은 뺀다. */
export const plainQuoteRequestPath = (
  productId: string,
  {
    colorOptionId,
    quantity,
  }: { readonly colorOptionId?: string | null; readonly quantity?: number | null },
): string => {
  const base = `${PLAIN_QUOTE_REQUEST_PATH}/${encodeURIComponent(productId)}`;
  const query = new URLSearchParams();
  if (colorOptionId !== undefined && colorOptionId !== null)
    query.set(CUSTOMIZE_COLOR_PARAM, colorOptionId);
  if (quantity !== undefined && quantity !== null)
    query.set(QUOTE_REQUEST_QTY_PARAM, String(quantity));
  const search = query.toString();
  return search === '' ? base : `${base}?${search}`;
};

/** 마이페이지 "내 견적" 목록·상세(견적 설계 §7·§12) — 마이페이지 아래에 둔다. /my 는 마이페이지 홈이다. */
export const MY_QUOTES_PATH = `${MY_PAGE_PATH}/quotes`;

/** 내 견적 목록이 읽는 페이지 번호 쿼리 이름. */
export const MY_QUOTES_PAGE_PARAM = 'page';

export const myQuotesPath = ({ page = 1 }: { page?: number } = {}): string =>
  page > 1 ? `${MY_QUOTES_PATH}?${MY_QUOTES_PAGE_PARAM}=${page}` : MY_QUOTES_PATH;

export const myQuoteDetailPath = (quoteRequestId: string): string =>
  `${MY_QUOTES_PATH}/${encodeURIComponent(quoteRequestId)}`;

export const ORDER_DEPOSIT_PATH = '/orders/deposit';
export const orderDepositPath = (orderId: string): string =>
  `${ORDER_DEPOSIT_PATH}/${encodeURIComponent(orderId)}`;
